import { Box, Button, IconButton, Menu, MenuItem } from "@mui/material";
import { useState } from "react";

export default function MuiTableAction({ theme, actions, handleActionClick }) {
    const [anchorEl, setAnchorEl] = useState(null);

    const handleMenuOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    if (actions.length === 0) {
        return null;
    }

    return (
        <Box>
            <Button onClick={handleMenuOpen}>Action</Button>
            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleMenuClose}
            >
                {actions.map((action) => (
                    <MenuItem
                        key={action.id}
                        onClick={() => {
                            handleActionClick(action);
                            handleMenuClose();
                        }}
                    >
                        {action.label}
                    </MenuItem>
                ))}
            </Menu>
        </Box>
    );
}
